.form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

/* The question is a step's heading, a little smaller than onboarding's. */
.form legend {
  font-size: 28px;
}
